import LogsService from '../services/LogsService'
import { Options } from 'highcharts'
import firebase from 'firebase/compat/app'
import localStorage from 'store'
import router from '../routes'
import store from '../store'

const proxyLoginCount = 'proxyLoginCount'

var inactivityTimer = null
var inactivityLimit = null

export const storageEventListener = async (e: StorageEvent) => {
  if (e.key === proxyLoginCount) {
    try {
      if (localStorage.get(proxyLoginCount) == 0) return
      if (localStorage.get(proxyLoginCount) == undefined) {
        console.log('user logged out on other tab')
        await store.dispatch('logout')
        await router.push({ name: 'login', params: { logout: 'true' } })
        return
      }
      if (!localStorage.get('a')) return
      const authState = await store.dispatch('auth/get')
      const authLocalStorage = JSON.parse(atob(localStorage.get('a')))
      console.log(authState, authLocalStorage)
      if (
        authState?.userId &&
        authLocalStorage?.userId &&
        authState?.userId !== authLocalStorage?.userId
      ) {
        const avoidRoutes = ['onboarding-trial-call', 'onboarding-success-call']
        const currentRoute = router.currentRoute.name || '';
        if(avoidRoutes.includes(currentRoute)) {
          console.log(
            'Avoid Reloading page for onboarding calls even if userID different in state and storage, Changed in other tabs'
          )
          return
        }
        console.log(
          'Reloading page as userID different in state and storage, Changed in other tabs'
        )
        window.location.reload()
        return
      }
    } catch (error) {
      console.error('Error while state and local storage user check', error)
    }
  } else if (e.key === 'lastActivity' && inactivityLimit && inactivityLimit !== 'NEVER') {
    const lastActivity = parseInt(e.newValue, 10);
    const currentTime = Date.now();

    // If activity occurred recently, reset the timer
    if (currentTime - lastActivity <= inactivityLimit) {
      resetInactivityTimer();
    }
  }
}

export const unhandledRejectionEventListener = async function ( event: PromiseRejectionEvent ) {
  if (event?.reason?.message === 'Missing or insufficient permissions.') {
    let authState, authLocalStorage, firebaseToken, claims

    try {
      authState = await store.dispatch('auth/get')
      authLocalStorage = JSON.parse(atob(localStorage.get('a')))
      // console.log('authState', authState, authLocalStorage)
      if (
        authState?.userId &&
        authLocalStorage?.userId &&
        authState?.userId !== authLocalStorage?.userId
      ) {
        console.log('Reloading page as userID different in state and storage')
        window.location.reload()
        return
      }
    } catch (error) {
      console.error('Error while state and local storage user check', error)
    }

    console.log('Logging out on Global Permissions error handler.')

    // Gather Firebase token and claims for logging
    try {
      firebaseToken = await firebase?.auth()?.currentUser?.getIdToken()
      // Get Firebase token claims safely
      if (firebaseToken) {
        try {
          const decodedToken = await firebase?.auth()?.currentUser?.getIdTokenResult()
          claims = decodedToken
        } catch (claimsErr) {
          console.warn('Unhandled Rejection > Failed to decode Firebase token claims:', claimsErr)
        }
      }
    } catch (err) {
      console.error('Error while getting firebase token and claims', err)
    }

    // Log the firebase token and claims
    try {
      await LogsService.dump('frontend-logout', {
        instance: 'Global Permissions error handler',
        origin: 'Unhandled Rejection Event',
        event: {
          message: event?.reason?.message,
          code: event?.reason?.code,
          stack: event?.reason?.stack,
        },
        page: window?.location?.href,
        route: {
          name: router.currentRoute.name,
          fullPath: router.currentRoute.fullPath
        },
        firebaseClaims: claims?.claims,
        firebaseToken,
        firebaseTokenMeta: {
          issuedAt: claims?.issuedAtTime,
          expirationTime: claims?.expirationTime
        }
      })
    } catch (err) {
      console.error('Error while logging firebase token and claims', err)
    }

    await store.dispatch('logout')
    await router.push({ name: 'login', params: { logout: 'true' } })
  } else {
    console.error('UnhandledRejectionEvent: ', event)
  }
}

export const fetchCompanyData = async()=>{
  try {
    const companyState = await store.dispatch('company/get')
    const inactiveSessionTimeLimit = companyState.inactiveSessionTimeLimit
    inactivityLimit = inactiveSessionTimeLimit ?? 'NEVER'
    if (inactivityLimit && inactivityLimit !== 'NEVER') {
      if (!localStorage.get('lastActivity')) {
        localStorage.set('lastActivity', Date.now().toString())
      }
      resetInactivityTimer()
    }
  } catch (error) {
    console.error('Error in fetchCompanyData:', error)
  }
}

// TODO: Memoize this function
export const resetInactivityTimer = () => {
  if (!inactivityLimit || inactivityLimit === 'NEVER') {
    if(inactivityTimer) clearTimeout(inactivityTimer)
    localStorage.remove('lastActivity')
  }
  if (inactivityTimer !== null)
    clearTimeout(inactivityTimer)
  if (localStorage.get('lastActivity')) {
    localStorage.set('lastActivity', Date.now().toString())
    inactivityTimer = setTimeout(async () => {
      await store.commit('auth/updateInactivityLogout', true)
      await store.dispatch('logout')
      await router.push({ name: 'login', params: { logout: 'true' } })
    }, parseInt(inactivityLimit) * 1000)
  }
}

export const highchartsTheme: Options = {
  colors: [
    '#0266C8',
    '#ff7a59',
    '#F2B50F',
    '#f28f43',
    '#77a1e5',
    '#c42525',
    '#a6c96a',
  ],
  chart: {
    style: {
      fontFamily: 'Roboto',
      color: '#444444',
    },
  },
  xAxis: {
    gridLineWidth: 1,
    gridLineColor: '#F3F3F3',
    lineColor: '#F3F3F3',
    minorGridLineColor: '#F3F3F3',
    tickColor: '#F3F3F3',
    tickWidth: 1,
  },
  yAxis: {
    gridLineColor: '#F3F3F3',
    lineColor: '#F3F3F3',
    minorGridLineColor: '#F3F3F3',
    tickColor: '#F3F3F3',
    tickWidth: 1,
  },
  legendBackgroundColor: 'rgba(0, 0, 0, 0.5)',
  background2: '#505053',
  dataLabelsColor: '#B0B0B3',
  textColor: '#C0C0C0',
  contrastTextColor: '#F0F0F3',
  maskColor: 'rgba(255,255,255,0.3)',
  lang: {
    thousandsSep: ',',
  },
}
